import styled from 'styled-components';

export const IconContainer = styled.span`
    display: inline-flex;
    transition: all 0.3s;

    &.clickable {
        cursor: pointer;

        &:hover {
            opacity: 0.5;
        }
    }

    &.primary {
        padding: 4px;
        border-radius: 4px;
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${(props) => props.theme.palette.primaryA5};
        color: ${(props) => props.theme.palette.primaryA1};
    }

    &.success {
        padding: 4px;
        border-radius: 4px;
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(82, 194, 127, 0.1);
        color: ${(props) => props.theme.palette.secondaryA3};
    }

    &.error {
        padding: 4px;
        border-radius: 4px;
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(255, 83, 135, 0.1);
        color: ${(props) => props.theme.palette.secondaryA4};
    }

    &.disabled {
        padding: 4px;
        border-radius: 4px;
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${(props) => props.theme.palette.secondaryA8};
        color: ${(props) => props.theme.palette.primaryA7};
    }

    &.circle {
        border-radius: 50%;
    }
`;
